import Nullstack from 'nullstack';
export default function IconBroadcast({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-broadcast",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M18.364 19.364a9 9 0 1 0 -12.728 0"
  }), "   ", Nullstack.element("path", {
    d: "M15.536 16.536a5 5 0 1 0 -7.072 0"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "13",
    r: "1"
  }), " ");
}